<template>
     <!-- FOOTER -->
     <footer id="footer-2" class="wide-60 footer division ">
            <div class="container">


                <!-- FOOTER CONTENT -->
                <div class="row d-flex align-items-center">


                    <!-- FOOTER ABOUT -->
                    <div class="col-md-4 col-lg-4 flogo ">
                        <div class="footer-info p-right-30 m-bottom-40">
                        
                            <!-- Footer Logo -->
                            <!-- For Retina Ready displays take a larger image, with double the amount of pixels that your image will be displayed (e.g 346 x 80 pixels) -->	
                            <img src="@/assets/images/logo.png" width="120" alt="footer-logo">

                        </div>
                    </div>


                    <!-- FOOTER SOCIAL LINKS -->
                    <!-- FOOTER LINKS -->
						<div class="col-md-3 col-lg-3 ft1">
							<div class="footer-links m-bottom-40">

								<!-- Title -->
								<h5 class="h5-md">APAYM</h5>

								<!-- Footer Links -->
								<ul class="foo-links clearfix">
									<li><a href="./tutos">Astuces APAYM</a></li>
									<li><RouterLink to="./lien-paiement">Lien de Paiement</RouterLink></li>
									<li><RouterLink to="/privileges">privilèges</RouterLink></li>
                                    <li><RouterLink to="/points-de-vente">Nos points de ventes</RouterLink></li>
									
								</ul>							

							</div>	
						</div>


						<!-- FOOTER LINKS -->
						<div class="col-md-3 col-lg-3 ft1">
							<div class="footer-links m-bottom-40">

								<!-- Title -->
								<h5 class="h5-md">A PROPOS</h5>

								<!-- Footer Links -->
								<ul class="foo-links clearfix">
									<li><RouterLink to="/qui-sommes-nous">Qui sommes nous</RouterLink></li>			
										
                                    <li><RouterLink to="/nous-contacter">Nous Contacter</RouterLink></li>	
                                    <li><RouterLink to="/faq">FAQs</RouterLink></li>					
									<li><RouterLink to="/tutos">Tutos</RouterLink></li>
									
								</ul>

							</div>	
						</div>


						<!-- FOOTER STORE BADGES -->
						<div class="col-md-2 col-lg-2 badge_footer">													
							<div class="footer-stores-badge text-right m-bottom-40">

								
                                <!-- Google Play -->
                                <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" target="_blank" class="store">
									<img class="appstore-original " src="@/assets/images/play_store_badge.webp" width="150"  alt="appstore-logo">
								</a>                               					
													
								<!-- AppStore -->
								<a href="https://apps.apple.com/app/id1211381693" target="_blank" class="store">
									<img class="googleplay-original" src="@/assets/images/app-store-bage.webp" width="150"  alt="googleplay-logo">
								</a>

                                <!-- App Gallery -->
								<a href="https://appgallery.huawei.com/app/C104470711" target="_blank" class="store">
									<img class="googleplay-original" src="@/assets/images/app-gallery-badge.webp" width="150"  alt="googleplay-logo">
								</a>
											
							</div>
						</div>	<!-- END FOOTER STORE BADGES -->


                </div>	<!-- END FOOTER CONTENT -->


                <!-- BOTTOM FOOTER -->
                <div class="bottom-footer">
                    <div class="row">


                        <!-- FOOTER COPYRIGHT -->
                        <div class="col-md-6">
                            <div class="footer-copyright">
                                <p>&copy; {{ currentYear }} <span>APAYM.</span> Tous droits réservés <RouterLink to="/mentions-legales" class="mention">Mentions légales</RouterLink> | Edité par <a href="https://weblogy.com" target="_blank"><span class="wby" data-v-52cc4c20="">W</span><span class="wbye" data-v-52cc4c20="">e</span><span class="wby" data-v-52cc4c20="">blogy</span></a>
                                    
                                </p>
                               
                            </div>
                        </div>


                        <!-- FOOTER LINKS -->
                        <div class="col-md-6">
                            <div class="footer-links text-right bt_mn_right">
                                <a href="https://weblogy.com/pci-dss"><img src="@/assets/images/pci-dss-certified.webp" class="img_pci pci_mob" alt="" width="100" target="_blank"></a>
                                <ul class="foo-links clearfix">
                                    <li><RouterLink to="apaym-pro" class="sub_link">APaym Pro</RouterLink></li>		
                                    <li><RouterLink to="qui-sommes-nous" class="sub_link">Qui sommes nous</RouterLink></li>
                                    <li><RouterLink to="nous-contacter" class="sub_link">Nous contacter</RouterLink></li>                                  
                                </ul>

                            </div>	
                        </div>

                    </div>	<!-- End row -->
                </div>	<!-- END BOTTOM FOOTER -->


            </div>	    <!-- End container -->
        </footer>	
        <!-- END FOOTER -->
</template>
<script>
export default{
    name :'footer_menu',

    data() {
    return {
      currentYear: ''
    }
  },
  created() {
    this.currentYear = new Date().getFullYear()
  }

}

</script>
<style scoped>

.img_pci {
    filter: grayscale(99%);
    transition-duration: 0.5s;
    opacity: 0.5;
}
.img_pci:hover {
    filter: grayscale(10%);
    transition-duration: 0.5s;
    opacity: 1;
}
.footer-stores-badge{
    text-align: left!important;;
}
.mention{
    font-weight: bold;
    font-size: 14px;
}
.mention:hover{
    font-weight: bold;
    font-size: 14px;
    text-decoration: underline;
}
.bt_mn_right{
    margin-top: -10px;
}

@font-face {
    font-family: ErasBookC;
    src: url(@/assets/fonts/ErasBookC.otf);
}
.wby{
font-family: ErasBookC;
font-weight: bold;
color: #000000;
}
.wby2{
font-family: ErasBookC;
  font-weight: bold;
  color: #fff;
  }
.wbye{
font-family: ErasBookC;
text-decoration: underline;
color:#fa0201;
font-weight: bold;
}



/*debut media query 768px*/

@media screen and (max-width: 767px) {
    
    .badge_footer{
    display: none;
    }

    .wide-60 {
    padding-top: 100px !important;
    padding-bottom: 60px;
}

.ft1{
    position: relative;
    width: 50% !important;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;  
}
.flogo{
    position: relative;
    width: 100% !important;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;    
}
.pci_mob{
    padding-top: 14px;
}
 
}
</style>